import com.soywiz.korge.Korge

suspend fun main(/*args: Array<String>*/) =
    Korge(Korge.Config(module = WishlairModule))

